import LiveManeuversPage from './LiveManeuvers';

export default function LiveMapAllManeuvers() {
  return <LiveManeuversPage mapAllOnly />;
}
